import { render, staticRenderFns } from "./EstimateClipboardItems.vue?vue&type=template&id=178b0863&"
import script from "./EstimateClipboardItems.vue?vue&type=script&lang=js&"
export * from "./EstimateClipboardItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports